import * as swcHelpers from '@swc/helpers';

const unwrapCartResponse = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(response) {
        if (response.ok) {
            return yield response.json();
        }
        if (response.status < 500) {
            return response.json().then((error)=>{
                throw error;
            });
        }
        throw new Error(`Got non OK response from server; ${response.status} ${response.statusText}`);
    });
    return function unwrapCartResponse(response) {
        return _ref.apply(this, arguments);
    };
}();

export { unwrapCartResponse };
//# sourceMappingURL=shared.js.map
